import axios from "axios";
import { QuotingType } from "../state/quote-reducer";
import { ApiUtils } from "./ApiUtils";

export class CalculationApi {
  private static readonly _baseUrl = ApiUtils.getBaseCalcUrl();

  public static getCalculation(request: QuotingType): Promise<any> {
    return axios.post(`${this._baseUrl}/calculations`, [request]);
  }
}
